import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/icons/solid/transportation-fill.svg'
import _imports_1 from '@/assets/icons/solid/image-fill.svg'
import _imports_2 from '@/assets/icons/solid/document-fill.svg'
import _imports_3 from '@/assets/icons/solid/list-bullet-fill.svg'


const _hoisted_1 = { class: "-mt-10 -mb-4" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]

import RoleDetails from './modals/roles/RoleDetails.vue' // components
	import InstructionDetails from './modals/roles/InstructionsDetails.vue'

	import { // language
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore
	} from '@/store/locales'

	import { 
		store as userStore
	} from '@/store/user'

	import { // vue
		computed,
		ref
	} from 'vue'

	
	const __default__ = { name: 'JobRoles' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		job: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props
	
	const _localesStore = localesStore()
	const _userStore = userStore()

	const {t} = useI18n()

	const roleDetailsBreadcrumb = computed(() => {
		if(currentModal.value === 'roleDetails') {
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.job?.fieldData?.name_bride_groom_display, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('179'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }}, // Roles
			]
		}else{
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.job?.fieldData?.name_bride_groom_display, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('179'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }}, // Roles
				{label: roleTitle, to: ""}, // Roles
				{label: _localesStore.getLabel('181'), to: ""}, // Roles
			]
		}
		
	})

	const selectedRole = ref({})
	const openToTab = ref(0)
	const roleDetailsModal = ref<{open: boolean}>({open: false})
	const currentModal = ref("roleDetails")
	const currentInstruction = ref()

	function showInstructions(row: any) {
		currentInstruction.value = row
		currentModal.value = "instructionDetails"
	}	

	const groupedData = computed(() => {
		let headings = []

		if(props?.job?.portalData?.portal_standard_roles?.length || props?.job?.portalData?.portal_standard_roles_staff?.length) {
			headings.push(
				{subheading: _localesStore.getLabel('393')},
				...props?.job?.portalData?.portal_standard_roles ?? [],
				...props?.job?.portalData?.portal_standard_roles_staff ?? []
			)
		}

		if(props?.job?.portalData?.portal_musician_roles?.length || props?.job?.portalData?.portal_musician_role_staff?.length) {
			headings.push(
				{subheading: _localesStore.getLabel('390')},
				...props?.job?.portalData?.portal_musician_roles ?? [],
				...props?.job?.portalData?.portal_musician_role_staff ?? []
			)
		}

		if(props?.job?.portalData?.portal_live_roles?.length || props?.job?.portalData?.portal_live_role_staff?.length) {
			headings.push(
				{subheading: _localesStore.getLabel('563')},
				...props?.job?.portalData?.portal_live_roles ?? [],
				...props?.job?.portalData?.portal_live_role_staff ?? []
			)
		}
		return headings
	})

	const modalTitle = computed(() => {
		if(currentModal.value === 'roleDetails') {
			return  selectedRole.value?.['job__job_role__ROLES__roleID_standard::name_display'] ||
				selectedRole.value?.['job__job_role__ROLES__roleID_instrumental::name_display'] ||
				selectedRole.value?.['job__job_role__ROLES__roleID_live::name_display'] || 
				selectedRole.value?.['job__job_role__ROLES__roleID_standard_gStaffID::name_display'] ||
				selectedRole.value?.['job__job_role__ROLES__roleID_instrumental_gStaffID::name_display'] ||
				selectedRole.value?.['job__job_role__ROLES__roleID_live_gStaffID::name_display']
		}
		else {
			return currentInstruction.value?.['jobs_roles__instructions_join_jobs__INSTRUCTIONS__instructionsID::name_display']
		}		
	})

	const roleTitle = computed(() => {
		return selectedRole.value?.['job__job_role__ROLES__roleID_standard::name_display'] ||
			selectedRole.value?.['job__job_role__ROLES__roleID_instrumental::name_display'] ||
			selectedRole.value?.['job__job_role__ROLES__roleID_live::name_display'] || 
			selectedRole.value?.['job__job_role__ROLES__roleID_standard_gStaffID::name_display'] ||
			selectedRole.value?.['job__job_role__ROLES__roleID_instrumental_gStaffID::name_display'] ||
			selectedRole.value?.['job__job_role__ROLES__roleID_live_gStaffID::name_display']		
	})
	
	function openModalDetails(row: any, tab: number) {
		selectedRole.value = row
		openToTab.value = tab
		currentModal.value = "roleDetails"
		roleDetailsModal.value.open = true
	}

	function restrictedModalOpen(row: any, tab: number) {
		if(isSignedInStaffRole(row)) {
			selectedRole.value = row
			openToTab.value = tab
			currentModal.value = "roleDetails"
			roleDetailsModal.value.open = true
		}
	}
	function modalClose() {
		roleDetailsModal.value.open = false
	}
	
	function hasCovidRestrictions(row: any) {
		if(_userStore.getContactType === 'Staff') {
			return row?.['job__JOBS_ROLES__standardJobID_gStaffID::covid_service'] ||
				row?.['job__JOBS_ROLES__standardJobID_gStaffID::covid_rehearsal'] ||
				row?.['job__JOBS_ROLES__instrumentalJobID_gStaffID::covid_rehearsal'] ||
				row?.['job__JOBS_ROLES__instrumentalJobID_gStaffID::covid_service'] ||
				row?.['job__JOBS_ROLES__liveJobID_gStaffID::covid_rehearsal'] ||
				row?.['job__JOBS_ROLES__liveJobID_gStaffID::covid_service']
		}
		else {
			return row?.['job__JOBS_ROLES__standardJobID::covid_service'] ||
				row?.['job__JOBS_ROLES__instrumentalJobID::covid_service'] ||
				row?.['job__JOBS_ROLES__liveJobID::covid_service'] || 
				row?.['job__JOBS_ROLES__standardJobID::covid_rehearsal'] ||
				row?.['job__JOBS_ROLES__instrumentalJobID::covid_rehearsal'] ||
				row?.['job__JOBS_ROLES__liveJobID::covid_rehearsal'] 
		}
	}
	
	function isSignedInStaffRole(row: any) {
		if(_userStore.getContactType === 'Staff') {
			return row?.['job__JOBS_ROLES__liveJobID_gStaffID::_kf_contacts_id'] === _userStore.user.contactId ||
				row?.['job__JOBS_ROLES__instrumentalJobID_gStaffID::_kf_contacts_id'] === _userStore.user.contactId ||
				row?.['job__JOBS_ROLES__standardJobID_gStaffID::_kf_contacts_id'] === _userStore.user.contactId
		}
		else {
			return true
		}
	}

	function hasPicture(row: any) {
		return row?.['job__job_role__CONTACTS_ROLES__contactRoleID_standard_gStaffID::s3JSONPicture'] || 
			row?.['job__job_role__CONTACTS_ROLES__contactRoleID_instrumental_gStaffID::s3JSONPicture'] || 
			row?.['job__job_role__CONTACTS_ROLES__contactRoleID_live_gStaffID::s3JSONPicture'] || 
			row?.['job__job_role__CONTACTS_ROLES__contactRoleID_live::s3JSONPicture'] || 
			row?.['job__job_role__CONTACTS_ROLES__contactRoleID_standard::s3JSONPicture'] || 
			row?.['job__job_role__CONTACTS_ROLES__contactRoleID_instrumental::s3JSONPicture']
	}

	function hasInstructions(row: any) {
		return row?.["job__job_role__INSTRUCTIONS_JOIN_JOBS__jobsRolesID_live_gStaffID::_kp_instructions_join_jobs_id"] ||
			row?.["job__job_role__INSTRUCTIONS_JOIN_JOBS__jobsRolesID_standard_gStaffID::_kp_instructions_join_jobs_id"] ||
			row?.["job__job_role__INSTRUCTIONS_JOIN_JOBS__jobsRolesID_instrumental_gStaffID::_kp_instructions_join_jobs_id"] 
	}

	function hasDocuments(row: any)	{
		return row?.["job__job_role__DOCUMENTS__contactRoleID_instrumental_gStaffID::_kp_documents_id"] ||
			row?.["job__job_role__DOCUMENTS__contactRoleID_live_gStaffID"] ||
			row?.["job__job_role__DOCUMENTS__contactRoleID_standard_gStaffID"] 
	}
	

	function hasTransportation(row: any) {
		return row?.['job_jobs_roles__TRANSPORTATION__gStaffID_instrumental_transportationID::type_display'] || 
			row?.['job_jobs_roles__TRANSPORTATION__gStaffID_standard_transportationID::type_display'] || 
			row?.['job_jobs_roles__TRANSPORTATION__gStaffID_live_transportationID::type_display'] || 
			row?.['job__JOBS_ROLES__instrumentalJobID_gStaffID::hotel'] || 
			row?.['job__JOBS_ROLES__standardJobID_gStaffID::hotel'] || 
			row?.['job__JOBS_ROLES__liveJobID_gStaffID::hotel']
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_CheckIconMini = _resolveComponent("CheckIconMini")!
  const _component_MinusIconMini = _resolveComponent("MinusIconMini")!
  const _component_tw_table = _resolveComponent("tw-table")!
  const _component_tw_modal = _resolveComponent("tw-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tw_table, {
      placeholder: _unref(t)('placeholders.noRoles'),
      data: groupedData.value,
      loading: __props.loading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_tw_table_column, {
          header: _unref(_localesStore).getLabel('102')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row['job__job_role__ROLES__roleID_standard::name_display'] ||
						row['job__job_role__ROLES__roleID_instrumental::name_display'] ||
						row['job__job_role__ROLES__roleID_live::name_display'] ||
						row['job__job_role__ROLES__roleID_standard_gStaffID::name_display'] ||
						row['job__job_role__ROLES__roleID_instrumental_gStaffID::name_display'] ||
						row['job__job_role__ROLES__roleID_live_gStaffID::name_display']), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        (_unref(_userStore).getContactType == 'Staff')
          ? (_openBlock(), _createBlock(_component_tw_table_column, {
              key: 0,
              header: _unref(_localesStore).getLabel('149')
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("div", null, _toDisplayString(row['job__job_role__CONTACTS__instrumental_staff_contactsPrimaryId::name_display'] ||
							row['job__job_role__CONTACTS__live_staff_contactsPrimaryId::name_display'] ||
							row['job__job_role__CONTACTS__standard_staff_contactsPrimaryId::name_display'] ||
							row['job__job_role__CONTACTS__instrumental_contactsPrimaryId::name_display'] ||
							row['job__job_role__CONTACTS__live_contactsPrimaryId::name_display'] ||
							row['job__job_role__CONTACTS__standard_contactsPrimaryId::name_display'] || "—"), 1)
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        _createVNode(_component_tw_table_column, {
          header: _unref(_localesStore).getLabel('411')
        }, {
          default: _withCtx(({row}) => [
            (row['job__JOBS_ROLES__standardJobID::standard'] ||
							row['job__JOBS_ROLES__instrumentalJobID::standard'] ||
							row['job__JOBS_ROLES__liveJobID::standard'] ||
							row['job__JOBS_ROLES__standardJobID_gStaffID::standard'] ||
							row['job__JOBS_ROLES__instrumentalJobID_gStaffID::standard'] ||
							row['job__JOBS_ROLES__liveJobID_gStaffID::standard'])
              ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                  key: 0,
                  class: "h-5 w-5 text-black"
                }))
              : (_openBlock(), _createBlock(_component_MinusIconMini, {
                  key: 1,
                  class: "h-5 w-5 text-gray-300"
                }))
          ]),
          _: 1
        }, 8, ["header"]),
        (_unref(_userStore).getContactType == 'Staff')
          ? (_openBlock(), _createBlock(_component_tw_table_column, {
              key: 1,
              header: _unref(_localesStore).getLabel('196')
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("div", null, _toDisplayString(row['job__JOBS_ROLES__standardJobID::status_display'] ||
							row['job__JOBS_ROLES__instrumentalJobID::status_display'] ||
							row['job__JOBS_ROLES__liveJobID::status_display'] ||
							row['job__JOBS_ROLES__standardJobID_gStaffID::status_display'] ||
							row['job__JOBS_ROLES__instrumentalJobID_gStaffID::status_display'] ||
							row['job__JOBS_ROLES__liveJobID_gStaffID::status_display'] || "—"), 1)
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_unref(_userStore).getContactType == 'Staff')
          ? (_openBlock(), _createBlock(_component_tw_table_column, {
              key: 2,
              header: _unref(_localesStore).getLabel('448')
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("div", null, _toDisplayString(_ctx.$filters.jpy(row['job__JOBS_ROLES__instrumentalJobID_gStaffID::role_cost'] ||
							row['job__JOBS_ROLES__standardJobID_gStaffID::role_cost'] ||
							row['job__JOBS_ROLES__liveJobID_gStaffID::role_cost']) || "—"), 1)
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_unref(_userStore).getContactType == 'Staff')
          ? (_openBlock(), _createBlock(_component_tw_table_column, {
              key: 3,
              header: _unref(_localesStore).getLabel('262')
            }, {
              default: _withCtx(({row}) => [
                (row['job__JOBS_ROLES__standardJobID::confirmed'] ||
							row['job__JOBS_ROLES__instrumentalJobID::confirmed'] ||
							row['job__JOBS_ROLES__liveJobID::confirmed'] ||
							row['job__JOBS_ROLES__standardJobID_gStaffID::confirmed'] ||
							row['job__JOBS_ROLES__instrumentalJobID_gStaffID::confirmed'] ||
							row['job__JOBS_ROLES__liveJobID_gStaffID::confirmed'])
                  ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                      key: 0,
                      class: "h-5 w-5 text-black"
                    }))
                  : (_openBlock(), _createBlock(_component_MinusIconMini, {
                      key: 1,
                      class: "h-5 w-5 text-gray-300"
                    }))
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_unref(_userStore).getContactType == 'Staff')
          ? (_openBlock(), _createBlock(_component_tw_table_column, {
              key: 4,
              header: _unref(_localesStore).getLabel('415')
            }, {
              default: _withCtx(({row}) => [
                (row['job__JOBS_ROLES__standardJobID::pickup'] ||
							row['job__JOBS_ROLES__instrumentalJobID::pickup'] ||
							row['job__JOBS_ROLES__liveJobID::pickup'] ||
							row['job__JOBS_ROLES__standardJobID_gStaffID::pickup'] ||
							row['job__JOBS_ROLES__instrumentalJobID_gStaffID::pickup'] ||
							row['job__JOBS_ROLES__liveJobID_gStaffID::pickup'])
                  ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                      key: 0,
                      class: "h-5 w-5 text-black"
                    }))
                  : (_openBlock(), _createBlock(_component_MinusIconMini, {
                      key: 1,
                      class: "h-5 w-5 text-gray-300"
                    }))
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_unref(_userStore).getContactType == 'Staff')
          ? (_openBlock(), _createBlock(_component_tw_table_column, {
              key: 5,
              header: _unref(_localesStore).getLabel('263')
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("div", null, _toDisplayString(_ctx.$filters.hour24Time(row['job__JOBS_ROLES__standardJobID::time_left'] ||
							row['job__JOBS_ROLES__instrumentalJobID::time_left'] ||
							row['job__JOBS_ROLES__liveJobID::time_left'] ||
							row['job__JOBS_ROLES__standardJobID_gStaffID::time_left'] ||
							row['job__JOBS_ROLES__instrumentalJobID_gStaffID::time_left'] ||
							row['job__JOBS_ROLES__liveJobID_gStaffID::time_left']) || "—"), 1)
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_unref(_userStore).getContactType == 'Staff')
          ? (_openBlock(), _createBlock(_component_tw_table_column, {
              key: 6,
              header: _unref(_localesStore).getLabel('264')
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("div", null, _toDisplayString(_ctx.$filters.hour24Time(row['job__JOBS_ROLES__standardJobID::time_arrived'] ||
							row['job__JOBS_ROLES__instrumentalJobID::time_arrived'] ||
							row['job__JOBS_ROLES__liveJobID::time_arrived'] ||
							row['job__JOBS_ROLES__standardJobID_gStaffID::time_arrived'] ||
							row['job__JOBS_ROLES__instrumentalJobID_gStaffID::time_arrived'] ||
							row['job__JOBS_ROLES__liveJobID_gStaffID::time_arrived']) || "—"), 1)
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        _createVNode(_component_tw_table_column, { "align-text": "right" }, {
          default: _withCtx(({row}) => [
            (isSignedInStaffRole(row))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([hasCovidRestrictions(row) ? 'link' : 'text-gray-500', 'cursor-pointer']),
                  onClick: ($event: any) => (openModalDetails(row, 0))
                }, _toDisplayString(_unref(_localesStore).getLabel('278')) + "... ", 11, _hoisted_2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_unref(_userStore).getContactType === 'Staff')
          ? (_openBlock(), _createBlock(_component_tw_table_column, {
              key: 7,
              "class-name": "w-6 ",
              "header-class-name": "w-6",
              "align-text": "right"
            }, {
              default: _withCtx(({row}) => [
                _withDirectives(_createElementVNode("div", {
                  class: "h-6 w-6 cursor-pointer",
                  onClick: ($event: any) => (restrictedModalOpen(row, isSignedInStaffRole(row) ? 1 : 0))
                }, [
                  _createElementVNode("img", {
                    class: _normalizeClass(hasTransportation(row) ? 'linked-icon' : 'grayed-icon'),
                    src: _imports_0,
                    alt: "list icon"
                  }, null, 2)
                ], 8, _hoisted_3), [
                  [_vShow, isSignedInStaffRole(row)]
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_tw_table_column, {
          "class-name": "w-6",
          "header-class-name": "w-6",
          "align-text": "right"
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", {
              class: "h-6 w-6 cursor-pointer",
              onClick: ($event: any) => (openModalDetails(row, _unref(_userStore).getContactType === 'Client' ? 1 : isSignedInStaffRole(row) ? 2 : 0))
            }, [
              _createElementVNode("img", {
                class: _normalizeClass([hasPicture(row) ? 'linked-icon' : 'grayed-icon']),
                src: _imports_1,
                alt: "picture icon"
              }, null, 2)
            ], 8, _hoisted_4)
          ]),
          _: 1
        }),
        (_unref(_userStore).getContactType === 'Staff')
          ? (_openBlock(), _createBlock(_component_tw_table_column, {
              key: 8,
              "class-name": "w-6 ",
              "header-class-name": "w-6",
              "align-text": "right"
            }, {
              default: _withCtx(({row}) => [
                _withDirectives(_createElementVNode("div", {
                  class: "h-6 w-6 cursor-pointer",
                  onClick: ($event: any) => (restrictedModalOpen(row, isSignedInStaffRole(row) ? 3 : 1))
                }, [
                  _createElementVNode("img", {
                    class: _normalizeClass([hasDocuments(row) ? 'linked-icon' : 'grayed-icon']),
                    src: _imports_2,
                    alt: "document icon"
                  }, null, 2)
                ], 8, _hoisted_5), [
                  [_vShow, isSignedInStaffRole(row)]
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(_userStore).getContactType == 'Staff' )
          ? (_openBlock(), _createBlock(_component_tw_table_column, {
              key: 9,
              "class-name": "w-5",
              "header-class-name": "w-5",
              "align-text": "right"
            }, {
              default: _withCtx(({row}) => [
                _withDirectives(_createElementVNode("div", {
                  class: "w-6 h-6",
                  onClick: ($event: any) => (restrictedModalOpen(row, 4))
                }, [
                  _createElementVNode("img", {
                    class: _normalizeClass([hasInstructions(row) ? 'linked-icon cursor-pointer ' : 'grayed-icon']),
                    src: _imports_3,
                    alt: "list icon"
                  }, null, 2)
                ], 8, _hoisted_6), [
                  [_vShow, isSignedInStaffRole(row)]
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["placeholder", "data", "loading"]),
    _createVNode(_component_tw_modal, {
      title: modalTitle.value,
      breadcrumb: roleDetailsBreadcrumb.value,
      "close-modal": modalClose,
      ref_key: "roleDetailsModal",
      ref: roleDetailsModal
    }, {
      default: _withCtx(() => [
        (currentModal.value === 'roleDetails')
          ? (_openBlock(), _createBlock(RoleDetails, {
              key: 0,
              role: selectedRole.value,
              "show-instructions": showInstructions,
              "open-to-tab": openToTab.value
            }, null, 8, ["role", "open-to-tab"]))
          : (currentModal.value === 'instructionDetails')
            ? (_openBlock(), _createBlock(InstructionDetails, {
                key: 1,
                instruction: currentInstruction.value,
                "show-details": openModalDetails,
                role: selectedRole.value
              }, null, 8, ["instruction", "role"]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "breadcrumb"])
  ]))
}
}

})